import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Content } from '../../entity/api/content';
import { type SeoResponse } from '../../entity/api/seo';
import { createBasicStoreState } from './basic-store';

type TModel = Content & {
  seo: SeoResponse;
};

type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'articles' }
  )
);
